// extracted by mini-css-extract-plugin
export var container = "VideoWidget-module--container--7b895";
export var videoWrapper = "VideoWidget-module--videoWrapper--48e36";